import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
} from '@chakra-ui/react';

const CategoryModals = ({
  isCreateModalOpen,
  isEditModalOpen,
  onCloseCreate,
  onCloseEdit,
  onSubmitCreate,
  onSubmitEdit,
  categories,
  formData,
  setFormData,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const renderCategoryOptions = (categories, depth = 0) => {
    return categories.map((category) => (
      <React.Fragment key={category.id}>
        <option value={category.id}>
          {'—'.repeat(depth)} {category.name}
        </option>
        {category.children?.length > 0 && renderCategoryOptions(category.children, depth + 1)}
      </React.Fragment>
    ));
  };

  return (
    <>
      {/* Create Category Modal */}
      <Modal isOpen={isCreateModalOpen} onClose={onCloseCreate}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Додати категорію</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Назва</FormLabel>
              <Input name="name" value={formData.name} onChange={handleChange} />
            </FormControl>
            <FormControl mt="4">
              <FormLabel>Батьківська категорія</FormLabel>
              <Select
                name="parent"
                placeholder="Без батьківської категорії"
                value={formData.parent}
                onChange={handleChange}
              >
                {renderCategoryOptions(categories)}
              </Select>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr="3" onClick={onSubmitCreate}>
              Зберегти
            </Button>
            <Button variant="ghost" onClick={onCloseCreate}>
              Скасувати
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Edit Category Modal */}
      <Modal isOpen={isEditModalOpen} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Редагувати категорію</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Назва</FormLabel>
              <Input name="name" value={formData.name} onChange={handleChange} />
            </FormControl>
            <FormControl mt="4">
              <FormLabel>Батьківська категорія</FormLabel>
              <Select
                name="parent"
                placeholder="Без батьківської категорії"
                value={formData.parent}
                onChange={handleChange}
              >
                {renderCategoryOptions(categories)}
              </Select>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr="3" onClick={onSubmitEdit}>
              Зберегти
            </Button>
            <Button variant="ghost" onClick={onCloseEdit}>
              Скасувати
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CategoryModals;
